export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    onlyOneChild: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
        icon = _context$props.icon,
        title = _context$props.title,
        active = _context$props.active,
        onlyOneChild = _context$props.onlyOneChild;
    var vnodes = [];

    if (icon) {
      vnodes.push(h("svg-icon", {
        "attrs": {
          "icon-class": active ? icon + '_active' : icon
        }
      }));
    }

    if (title) {
      if (onlyOneChild) {
        if (icon === '') {
          vnodes.push(h("span", {
            "style": 'padding-left:10px;'
          }, [title]));
        } else {
          vnodes.push(h("span", [title]));
        }
      } else {
        vnodes.push(h("span", {
          "slot": 'title'
        }, [title]));
      }
    }

    return vnodes;
  }
};